import { render, staticRenderFns } from "./dingSign.vue?vue&type=template&id=0f26f4b4&"
import script from "./dingSign.vue?vue&type=script&lang=js&"
export * from "./dingSign.vue?vue&type=script&lang=js&"
import style0 from "./dingSign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports